import {useParams} from 'react-router-dom';
import {Alert, Stack} from '@mantine/core';
import {I18n} from '@aws-amplify/core';

import {FormPageLayout, PlatformLoader} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile.tsx';
import {EditPageNavigation} from '../navigation/EditPageNavigation.tsx';
import {useUsageEvent} from '../hooks/useUsageEvent.ts';
import {moduleConfig} from '../config';

// FNP-536: read-only detail view of a single raw UsageEvent. No edit drawer / tools —
// the FNP-215 ingestion writer owns the lifecycle. Renders the identity, attribution,
// and the free-form attributes payload.
export const DetailPage = () => {
    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const {
        record: usageEvent,
        loading,
        isError,
        notFound,
    } = useUsageEvent(id);

    if (loading) {
        return <PlatformLoader message={I18n.get('Loading usage event...Please wait')}/>;
    }

    // Never hang on the loader, and never call a failed load "not found": an auth or
    // network error says so, a missing record says so.
    if (isError) {
        return (
            <Alert color='red' title={I18n.get('Could not load usage event')}>
                {I18n.get('The billing API returned an error for id')} <code>{id}</code>.
            </Alert>
        );
    }

    if (notFound || !usageEvent) {
        return (
            <Alert color='gray' title={I18n.get('Usage event not found')}>
                {I18n.get('No usage event found for id')} <code>{id}</code>.
            </Alert>
        );
    }

    return (
        <FormPageLayout
            title={`${I18n.get(moduleConfig.titles.singular)}: ${usageEvent.eventId}`}
            pageNavigation={<EditPageNavigation component={usageEvent}/>}
        >
            <Stack gap='lg'>
                <Profile record={usageEvent}/>
            </Stack>
        </FormPageLayout>
    );
};
